// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5217":"9ad4f7935b8b2f55","8857":"5af727735e96e2cd"}[chunkId] + ".js";
};